/**
 * Logger instance (https://riptutorial.com/vue-js/example/27220/simple-logger)
 */
const Logger = {

	log(...args) {
		if (process.env.NODE_ENV !== "production") {
			console.log(...args);
		}
	},

	error(...args) {
		if (process.env.NODE_ENV !== "production") {
			console.error(...args);
		}

		// report the error
		var jsonString,
		obj = new Object();

		obj.action = "errVideoPlayer";
		obj.src = "Logger";
		obj.data = JSON.stringify(args);

		jsonString = JSON.stringify(obj);

		window.jQuery.ajax({
			url : process.env.VUE_APP_VIDEO_PLAYER_SERVICE_URL,
			data : jsonString,
			contentType : "application/json",
			cache : false,
			type : "POST"
		});
	},

	warn(...args) {
		if (process.env.NODE_ENV !== "production") {
			console.warn(...args);
		}
	},

	install(Vue, options) {
		Vue.prototype.$logger = Logger;
	}
}

export default Logger;
